let obj = {
    "1": [
        { "lat": 25.117932, "lng": 121.549301 },
        { "lat": 25.097103, "lng": 121.551018 },
        { "lat": 25.087775, "lng": 121.553078 },
        { "lat": 25.084666, "lng": 121.585007 },
        { "lat": 25.087775, "lng": 121.599426 },
        { "lat": 25.084977, "lng": 121.609039 },
        { "lat": 25.074094, "lng": 121.611786 },
        { "lat": 25.070051, "lng": 121.616936 },
        { "lat": 25.084666, "lng": 121.667747 },
        { "lat": 25.069118, "lng": 121.691093 },
        { "lat": 25.057922, "lng": 121.645775 },
        { "lat": 25.037705, "lng": 121.625862 },
        { "lat": 24.995705, "lng": 121.581573 },
        { "lat": 24.953067, "lng": 121.540031 },
        { "lat": 24.969875, "lng": 121.513939 },
        { "lat": 24.985124, "lng": 121.483727 },
        { "lat": 24.955246, "lng": 121.424675 },
        { "lat": 24.926295, "lng": 121.388283 },
        { "lat": 24.925672, "lng": 121.363907 },
        { "lat": 24.935635, "lng": 121.332321 },
        { "lat": 24.896402, "lng": 121.289749 },
        { "lat": 24.878962, "lng": 121.299706 },
        { "lat": 24.853731, "lng": 121.293526 },
        { "lat": 24.865257, "lng": 121.261940 },
        { "lat": 24.810733, "lng": 121.205635 },
        { "lat": 24.835972, "lng": 121.182976 },
        { "lat": 24.898894, "lng": 121.169586 },
        { "lat": 24.915086, "lng": 121.098862 },
        { "lat": 24.925361, "lng": 121.086845 },
        { "lat": 25.022773, "lng": 121.206322 },
        { "lat": 25.071917, "lng": 121.191902 },
        { "lat": 25.116067, "lng": 121.256104 },
        { "lat": 25.082489, "lng": 121.357040 },
        { "lat": 25.096792, "lng": 121.376953 },
        { "lat": 25.091818, "lng": 121.395493 },
        { "lat": 25.081246, "lng": 121.423645 },
        { "lat": 25.126014, "lng": 121.443558 },
        { "lat": 25.150257, "lng": 121.490936 },
        { "lat": 25.151500, "lng": 121.524582 }
    ],
    "2": [
        { "lat": 24.886436, "lng": 121.061783 },
        { "lat": 24.868371, "lng": 121.066589 },
        { "lat": 24.850927, "lng": 121.039810 },
        { "lat": 24.822886, "lng": 121.042557 },
        { "lat": 24.807305, "lng": 121.030884 },
        { "lat": 24.760549, "lng": 121.021271 },
        { "lat": 24.746831, "lng": 121.014404 },
        { "lat": 24.738101, "lng": 120.984879 },
        { "lat": 24.708163, "lng": 120.942307 },
        { "lat": 24.743713, "lng": 120.905914 },
        { "lat": 24.800448, "lng": 120.934753 },
        { "lat": 24.830364, "lng": 120.947113 },
        { "lat": 24.846565, "lng": 120.969772 },
        { "lat": 24.860273, "lng": 120.984192 },
        { "lat": 24.895779, "lng": 121.019211 }
    ],
    "3": [
        { "lat": 24.708787, "lng": 120.870895 },
        { "lat": 24.720014, "lng": 120.888062 },
        { "lat": 24.685705, "lng": 120.923080 },
        { "lat": 24.661370, "lng": 120.888748 },
        { "lat": 24.635159, "lng": 120.872269 },
        { "lat": 24.598953, "lng": 120.839996 },
        { "lat": 24.582720, "lng": 120.853729 },
        { "lat": 24.553993, "lng": 120.847549 },
        { "lat": 24.544000, "lng": 120.839996 },
        { "lat": 24.468401, "lng": 120.826263 },
        { "lat": 24.469026, "lng": 120.792618 },
        { "lat": 24.473400, "lng": 120.773392 },
        { "lat": 24.521513, "lng": 120.774765 },
        { "lat": 24.565235, "lng": 120.797424 },
        { "lat": 24.589588, "lng": 120.789185 },
        { "lat": 24.605196, "lng": 120.774078 },
        { "lat": 24.662618, "lng": 120.830383 }
    ],
    "4": [
        { "lat": 24.256355, "lng": 120.582504 },
        { "lat": 24.252599, "lng": 120.628510 },
        { "lat": 24.238199, "lng": 120.648422 },
        { "lat": 24.265745, "lng": 120.673141 },
        { "lat": 24.278264, "lng": 120.687561 },
        { "lat": 24.282020, "lng": 120.723953 },
        { "lat": 24.275761, "lng": 120.754166 },
        { "lat": 24.240704, "lng": 120.739059 },
        { "lat": 24.205637, "lng": 120.727386 },
        { "lat": 24.174946, "lng": 120.745926 },
        { "lat": 24.136728, "lng": 120.743179 },
        { "lat": 24.087216, "lng": 120.735626 },
        { "lat": 24.050853, "lng": 120.697174 },
        { "lat": 24.029532, "lng": 120.644302 },
        { "lat": 24.075305, "lng": 120.607910 },
        { "lat": 24.047718, "lng": 120.561905 },
        { "lat": 23.981861, "lng": 120.592804 },
        { "lat": 23.926013, "lng": 120.605164 },
        { "lat": 23.812988, "lng": 120.501480 },
        { "lat": 23.843766, "lng": 120.441055 },
        { "lat": 23.934172, "lng": 120.436935 },
        { "lat": 24.037685, "lng": 120.482941 },
        { "lat": 24.089724, "lng": 120.503540 },
        { "lat": 24.122942, "lng": 120.485001 },
        { "lat": 24.146754, "lng": 120.513840 },
        { "lat": 24.122315, "lng": 120.563278 },
        { "lat": 24.161790, "lng": 120.576324 },
        { "lat": 24.231312, "lng": 120.603790 }
    ],
    "5": [
        { "lat": 23.812988, "lng": 120.444489 },
        { "lat": 23.787858, "lng": 120.546799 },
        { "lat": 23.709295, "lng": 120.592117 },
        { "lat": 23.635089, "lng": 120.546799 },
        { "lat": 23.561470, "lng": 120.493240 },
        { "lat": 23.472064, "lng": 120.504227 },
        { "lat": 23.428599, "lng": 120.474701 },
        { "lat": 23.417258, "lng": 120.362778 },
        { "lat": 23.438049, "lng": 120.301666 },
        { "lat": 23.571540, "lng": 120.314026 },
        { "lat": 23.680372, "lng": 120.375824 },
        { "lat": 23.769007, "lng": 120.396423 }
    ],
    "6": [
        { "lat": 23.374405, "lng": 120.311279 },
        { "lat": 23.403395, "lng": 120.399857 },
        { "lat": 23.398984, "lng": 120.424576 },
        { "lat": 23.341941, "lng": 120.430412 },
        { "lat": 23.282665, "lng": 120.383034 },
        { "lat": 23.264373, "lng": 120.371361 },
        { "lat": 23.268158, "lng": 120.316772 },
        { "lat": 23.283611, "lng": 120.272484 },
        { "lat": 23.333429, "lng": 120.300980 }
    ],
    "7": [
        { "lat": 23.088575, "lng": 120.186310 },
        { "lat": 23.132152, "lng": 120.254288 },
        { "lat": 23.163720, "lng": 120.302353 },
        { "lat": 23.152356, "lng": 120.336685 },
        { "lat": 23.069624, "lng": 120.320206 },
        { "lat": 23.024132, "lng": 120.321579 },
        { "lat": 22.992531, "lng": 120.316086 },
        { "lat": 22.943218, "lng": 120.224075 },
        { "lat": 22.941321, "lng": 120.175323 },
        { "lat": 22.995691, "lng": 120.143051 },
        { "lat": 23.031083, "lng": 120.182877 }
    ],
    "8": [
        { "lat": 22.882818, "lng": 120.244675 },
        { "lat": 22.886297, "lng": 120.326729 },
        { "lat": 22.873645, "lng": 120.331535 },
        { "lat": 22.831250, "lng": 120.323639 },
        { "lat": 22.755921, "lng": 120.345268 },
        { "lat": 22.744839, "lng": 120.370674 },
        { "lat": 22.705255, "lng": 120.362434 },
        { "lat": 22.685934, "lng": 120.372047 },
        { "lat": 22.666294, "lng": 120.372391 },
        { "lat": 22.652037, "lng": 120.397797 },
        { "lat": 22.614011, "lng": 120.416679 },
        { "lat": 22.562659, "lng": 120.413246 },
        { "lat": 22.547757, "lng": 120.370331 },
        { "lat": 22.530951, "lng": 120.350075 },
        { "lat": 22.622251, "lng": 120.269394 },
        { "lat": 22.636828, "lng": 120.278320 },
        { "lat": 22.656473, "lng": 120.271454 },
        { "lat": 22.674847, "lng": 120.283470 },
        { "lat": 22.712223, "lng": 120.286217 },
        { "lat": 22.748955, "lng": 120.273514 },
        { "lat": 22.833782, "lng": 120.251198 }
    ],
    "9": [
        { "lat": 22.664710, "lng": 120.443115 },
        { "lat": 22.712856, "lng": 120.470581 },
        { "lat": 22.762886, "lng": 120.466461 },
        { "lat": 22.758453, "lng": 120.498047 },
        { "lat": 22.722990, "lng": 120.533752 },
        { "lat": 22.684984, "lng": 120.570145 },
        { "lat": 22.625420, "lng": 120.546799 },
        { "lat": 22.605137, "lng": 120.537872 },
        { "lat": 22.613377, "lng": 120.449295 }
    ],
    "10": [
        { "lat": 22.686251, "lng": 121.065388 },
        { "lat": 22.702405, "lng": 121.038437 },
        { "lat": 22.718715, "lng": 121.049595 },
        { "lat": 22.744048, "lng": 121.055946 },
        { "lat": 22.774124, "lng": 121.080494 },
        { "lat": 22.801662, "lng": 121.097145 },
        { "lat": 22.789160, "lng": 121.115341 },
        { "lat": 22.807200, "lng": 121.123409 },
        { "lat": 22.788843, "lng": 121.141949 },
        { "lat": 22.778239, "lng": 121.144180 },
        { "lat": 22.756079, "lng": 121.169758 },
        { "lat": 22.709056, "lng": 121.109505 }
    ],
    "11": [
        { "lat": 23.920521, "lng": 121.592560 },
        { "lat": 23.927425, "lng": 121.552906 },
        { "lat": 23.936212, "lng": 121.537113 },
        { "lat": 23.943115, "lng": 121.532478 },
        { "lat": 23.982175, "lng": 121.559944 },
        { "lat": 24.026397, "lng": 121.588097 },
        { "lat": 24.035020, "lng": 121.593246 },
        { "lat": 24.042702, "lng": 121.621399 },
        { "lat": 24.017773, "lng": 121.643028 },
        { "lat": 23.988135, "lng": 121.633759 },
        { "lat": 23.960686, "lng": 121.608181 },
        { "lat": 23.946096, "lng": 121.606293 }
    ],
    "12": [
        { "lat": 24.660746, "lng": 121.836319 },
        { "lat": 24.655130, "lng": 121.747055 },
        { "lat": 24.672602, "lng": 121.707916 },
        { "lat": 24.739348, "lng": 121.711349 },
        { "lat": 24.782994, "lng": 121.750488 },
        { "lat": 24.823509, "lng": 121.765594 },
        { "lat": 24.846565, "lng": 121.800613 },
        { "lat": 24.834103, "lng": 121.826019 },
        { "lat": 24.778007, "lng": 121.820526 },
        { "lat": 24.728122, "lng": 121.832199 }
    ]
}

export default obj;


// WEBPACK FOOTER //
// ./src/greenArea.js